import type { ServicePhase } from "@/data/service";

export function ServiceLoopDiagram({ phases }: { phases: ServicePhase[] }) {
  return (
    <div className="relative grid grid-cols-4 items-center rounded-xl border border-[var(--line)] bg-paper-warm px-2 py-5 xs:px-4">
      <div
        className="absolute left-4 right-4 top-[38px] z-[1] h-px bg-forest-500 opacity-40"
        aria-hidden
      />
      {phases.map((p) => (
        <div
          key={p.n}
          className="relative z-[2] flex flex-col items-center gap-2"
        >
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-forest-900 font-mono text-xs font-semibold text-paper shadow-[0_0_0_4px_#FBFBF7]">
            {String(p.n).padStart(2, "0")}
          </div>
          <span className="text-center text-[11px] font-bold leading-tight tracking-tight text-ink-900 xs:text-[13.5px]">
            {p.title}
          </span>
          <span className="text-center font-mono text-[8.5px] uppercase tracking-widest text-ink-400 xs:text-[9.5px]">
            {p.sub}
          </span>
        </div>
      ))}
    </div>
  );
}
